import { z } from 'zod';
/**
 * POST /api/trial/activate — 체험 VM 자동 발급 (기계 간 호출, API 키 인증).
 *
 * 체험 VM 을 만드는 자동화(핸즈온 허브 → GitHub Actions)가 부른다. 사람이 challenge 를 붙여넣는 대신
 * VM 의 hwid 를 직접 보내고, 서버가 「체험」 고객 아래에 라이선스를 새로 만들어 바로 서명한다.
 */
export const TrialActivateRequestSchema = z.object({
    /** 체험 VM 의 HW fingerprint — aisight `GET /api/license/status` 의 hwid (sha256 hex). */
    hwid: z.string().regex(/^[0-9a-f]{64}$/, 'hwid 는 64자리 소문자 hex 여야 합니다.'),
    /** 체험 VM 식별자 (예: t-0001). 라이선스 메모에 남는다. */
    trialName: z.string().trim().min(1).max(63),
    /** 체험 신청자 이메일 — 메모용(선택). */
    email: z.string().trim().email().max(200).optional(),
    /** 라이선스 만료 시각(ISO). 보통 체험 마지막 날 다음 0시. 서버 상한(INNERMATELIC_TRIAL_MAX_DAYS)을 넘으면 거부. */
    expiresAt: z.string().datetime({ offset: true }),
    /** 등급 키. 생략하면 서버 기본(INNERMATELIC_TRIAL_LEVEL, 없으면 INNERMATELIC_TRIAL_FEATURES 기능 목록 — 기본 base). */
    level: z.string().min(1).optional(),
    /** 최대 동시 사용자 수. 생략 = 무제한. */
    maxUsers: z.number().int().positive().max(10000).optional(),
    /** 체험 VM 의 aisight 버전(선택). */
    appVersion: z.string().max(40).optional(),
});
/** POST /api/trial/revoke — 체험 종료(VM 삭제) 때 그 VM 이름의 체험 라이선스 회수 */
export const TrialRevokeRequestSchema = z.object({
    trialName: z.string().trim().min(1).max(63),
    reason: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=trial.js.map